<template>
  <div class="tw-py-4 tw-px-6 tw-flex tw-flex-col tw-gap-4">
    <template v-for="comm in items" :key="`${comm.kind}-${comm.id}`">
      <RemarkCard
        v-if="comm.kind === 'remark-card'"
        :remark="comm"
        show-context-btn
        show-context
        show-tags
        part-of="inbox"
      />
      <NotificationContent v-else type="CheckList" :communication-item="comm" />
    </template>
    <div
      class="
        tw-mx-auto
        tw-my-4
        tw-font-medium
        tw-text-sm
        tw-text-sf-gray-light
        tw-text-center
      "
    ></div>
  </div>
</template>

<script setup>
import RemarkCard from '@app/shared/vue/components/molecules/remark/remark-card.vue'
import NotificationContent from '@app/application/communication/screens/inbox/components/notification-content.vue'

defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>
